import http from '@/http/aisea/axios'

export default {
  // 法人船舶別動静レポート一覧取得API
  fetchReports(payload) {
    return http.get(`/vessel_report/enterprise/vessels/${payload.vessel_id}/reports`, {
      params: payload.params
    });
  },
  // 航海記録情報取得API
  fetchVoyageHistoryDetail(payload) {
    return http.get(`/voyage_history/${payload.voyage_history_id}`);
  },
}